/**
 * Rewrite an absolute admin deep-link (`/admin/...`) to the current shell's base
 * path so dealer-shell links land under `/dealer/...`. The query string is
 * preserved (e.g. `?tab=billing`). Returns the link unchanged on `/admin`.
 *
 * Shared by the alerts bell dropdown and the alerts inbox page (TASK-3676);
 * kept in its own module so neither component file exports a non-component
 * (React Fast Refresh constraint).
 */
export function rewriteAlertLink(
  link: string | null,
  basePath: string,
): string | null {
  if (!link || basePath === "/admin") {
    return link;
  }
  return link.replace(/^\/admin/, basePath);
}
